export default "__VITE_ASSET__C46FQLvE__"